import { render } from "./UserHomeFallback.vue?vue&type=template&id=1a182ca6"
import script from "./UserHomeFallback.vue?vue&type=script&lang=js"
export * from "./UserHomeFallback.vue?vue&type=script&lang=js"

import exportComponent from "/Users/georgwidschwendter/Documents/GitHub/learn/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__